// js/captain_script.js

// =========================================
// 初期化処理
// =========================================
document.addEventListener('DOMContentLoaded', () => {
  // カートバッジの件数を最新にする
  updateCartBadge();

  // 口コミ（Voice）の無限ループ初期化
  initInfiniteVoice();

  // カートドロワー（スライドイン式カート）の初期化
  initCartDrawer();
});

// =========================================
// Shopify API連携機能 (カート操作)
// =========================================

// カート追加の通信中かどうか（連打による二重追加を防ぐ）
let captainIsAdding = false;

/**
 * 商品をカートに追加する (Ajax)
 * @param {string|number} variantId - 追加するバリエーションID
 * @param {number} qty - 数量 (デフォルト1)
 * @param {string|number|null} sellingPlanId - 定期便のプランID (ない場合はnull)
 */
function addToCart(variantId, qty = 1, sellingPlanId = null) {
  // 送信中に連打されると同じ商品が二重に入るため、終わるまで受け付けない
  if (captainIsAdding) return;
  captainIsAdding = true;

  // ▼▼▼ 修正箇所：ここから最強版に変更 ▼▼▼
  // もし引数で定期便IDが渡されていなくても、画面内にウィジェットがあればその値を拾う
  if (!sellingPlanId) {
    // 1. まず標準の隠しフィールドを探す
    const widgetInput = document.querySelector('input[name="selling_plan"]');
    if (widgetInput && widgetInput.value) {
      sellingPlanId = widgetInput.value;
    } 
    // 2. なければ、チェックされているラジオボタンを直接探しに行く (ここが重要)
    else {
      const checkedRadio = document.querySelector('input[data-selling-plan-id]:checked');
      if (checkedRadio) {
        sellingPlanId = checkedRadio.getAttribute('data-selling-plan-id');
      }
    }
  }
  // ▲▲▲ 修正箇所：ここまで ▲▲▲

  // 送信データを作成
  const itemData = {
    'id': variantId,
    'quantity': qty
  };

  // 定期便IDがある場合のみ追加
  if (sellingPlanId) {
    itemData['selling_plan'] = sellingPlanId;
  }

  const formData = {
    'items': [itemData]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    if (data.status) {
      console.error(data);
      // 定期便必須なのにプランがない場合のエラーハンドリング
      alert('エラー: 定期便プランが正しく選択されていません。\n(プランのラジオボタンが選択されているかご確認ください)');
    } else {
      // 成功時：ヘッダーの数字を更新し、カートをその場でスライド表示する
      // （通知だけだと「カートを見るボタン」を探して上までスクロールする必要があり、離脱の原因になるため）
      updateCartBadge();
      openCartDrawer();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('通信エラーが発生しました。');
  })
  .finally(() => {
    captainIsAdding = false;
  });
}

/**
 * カート内の数量を変更する (カートページ用)
 * ※在庫不足(422エラー)のハンドリング付き
 * @param {string} key - カート内アイテムのKey (またはVariant ID)
 * @param {number} qty - 新しい数量
 */
function updateCartQty(key, qty) {
  if (qty < 0) qty = 0;

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: qty
    })
  })
  .then(response => {
    // 成功 (200 OK)
    if (response.ok) {
      return response.json();
    } 
    // 失敗 (422 Unprocessable Entityなど)
    else {
      throw response; 
    }
  })
  .then(cart => {
    // 成功したら画面をリロードして最新状態を表示
    window.location.href = '/cart';
  })
  .catch(error => {
    // エラーレスポンスの処理
    if (error.json) {
      error.json().then(errData => {
        // 在庫不足などのメッセージを表示
        alert(errData.description || "在庫が不足しているため、これ以上数量を増やせません。");
        // 画面をリロードして元の数量に戻す
        window.location.href = '/cart';
      });
    } else {
      console.error('Error:', error);
      alert("カートの更新に失敗しました。");
      window.location.href = '/cart';
    }
  });
}

/**
 * ヘッダーのカートバッジ数を更新する
 */
function updateCartBadge() {
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(cart => {
    const badge = document.getElementById('cart-badge');
    if (badge) {
      badge.textContent = cart.item_count;
    }
    // 画面下の固定ボタンもカートの状態に合わせて切り替える
    updateStickyCta(cart);
  });
}

// =========================================
// UI・演出機能
// =========================================

// 通知メッセージを表示
function showNotification(msg) {
  const notif = document.getElementById('notification');
  const notifMsg = document.getElementById('notification-msg');

  if (notif && notifMsg) {
    notifMsg.innerText = msg;
    notif.classList.add('is-visible');

    // 3秒後に消す
    setTimeout(() => {
      notif.classList.remove('is-visible');
    }, 3000);
  }
}

// =========================================
// 商品詳細ページ用機能
// =========================================

// 画像の切り替え
function changeImage(src) {
  const mainImage = document.getElementById('MainImage');
  if (mainImage) {
    mainImage.src = src;
  }
}

// 数量変更（商品ページ用）
function adjustQty(delta) {
  const qtyInput = document.getElementById('Quantity');
  if (!qtyInput) return;

  let currentVal = parseInt(qtyInput.value);
  if (isNaN(currentVal)) currentVal = 1;

  const newVal = currentVal + delta;

  if (newVal >= 1) {
    qtyInput.value = newVal;
  }
}

// =========================================
// 新・User Voice 無限ループ (クローン方式)
// =========================================
function initInfiniteVoice() {
  const track = document.getElementById('voiceTrack');
  const btnPrev = document.getElementById('btn-prev');
  const btnNext = document.getElementById('btn-next');
  
  // 要素がない場合は終了
  if (!track || !btnPrev || !btnNext) return;

  const originalCards = Array.from(track.children);
  const cardCount = originalCards.length;
  if (cardCount === 0) return;

  // カード幅 + ギャップ(gap)を取得
  const cardStyle = window.getComputedStyle(track);
  const gap = parseFloat(cardStyle.columnGap) || 24;
  const cardWidth = originalCards[0].offsetWidth + gap;

  // ------------------------------------------------
  // 1. クローンを作成して配置 [クローン] [本物] [クローン]
  // ------------------------------------------------
  
  // 前へのクローン (全要素分)
  originalCards.forEach(card => {
    const clone = card.cloneNode(true);
    clone.classList.add('is-clone'); 
    clone.setAttribute('aria-hidden', 'true');
    track.insertBefore(clone, track.firstChild);
  });

  // 後ろへのクローン (全要素分)
  originalCards.forEach(card => {
    const clone = card.cloneNode(true);
    clone.classList.add('is-clone');
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  // ------------------------------------------------
  // 2. 初期位置合わせ (真ん中の [本物] の先頭へ)
  // ------------------------------------------------
  // クローンが前に追加された分、スクロール位置をずらす
  const initialScroll = cardCount * cardWidth;
  track.scrollLeft = initialScroll;

  // ------------------------------------------------
  // 3. スクロール監視 (瞬間移動ロジック)
  // ------------------------------------------------
  let isScrolling = false;
  track.addEventListener('scroll', () => {
    if (isScrolling) return; // ボタン操作中は監視しない

    // 現在のスクロール位置
    const currentScroll = track.scrollLeft;
    
    // 全体の幅 (クローン含む)
    // [セット1][セット2(本物)][セット3]
    // セット1の終わり = initialScroll
    // セット2の終わり = initialScroll * 2

    // ■ 右に行き過ぎた場合 (セット3に入った)
    if (currentScroll >= initialScroll * 2) {
      // セット2(本物)の頭へ瞬間移動
      track.scrollLeft = currentScroll - initialScroll;
    }
    // ■ 左に行き過ぎた場合 (セット1に入った)
    else if (currentScroll <= 0) {
      // セット2(本物)の同じ位置へ瞬間移動
      track.scrollLeft = currentScroll + initialScroll;
    }
  });

  // ------------------------------------------------
  // 4. ボタン操作
  // ------------------------------------------------
  const scrollAmount = cardWidth; // 1回で動く幅

  btnNext.addEventListener('click', () => {
    // 滑らかに右へ
    track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  btnPrev.addEventListener('click', () => {
    // 滑らかに左へ
    track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });
}

// =========================================
// カートドロワー（スライドイン式カート）
// =========================================

// 送料無料になる金額（円）※ヘッダーのキャンペーンバー表記と揃える
const CAPTAIN_FREE_SHIPPING_YEN = 4800;
// 1回の注文で配送できる重量の上限（g）※カートページの判定と揃える
const CAPTAIN_WEIGHT_LIMIT_G = 20000;

// ドロワーを開く前にフォーカスしていた要素（閉じたときに戻すため）
let captainLastFocused = null;

/**
 * 金額表示を作る
 * Shopify の Ajax API は金額を「最小通貨単位」で返すため 100 で割る
 * @param {number} cents
 * @returns {string} 例: ¥4,800
 */
function formatMoney(cents) {
  return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
}

/**
 * HTMLに差し込む文字列を無害化する（商品名などにタグが含まれても壊れないように）
 * @param {string} str
 */
function escapeHtml(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * カートドロワーの初期化（クリックやキー操作の割り当て）
 */
function initCartDrawer() {
  const modal = document.getElementById('cart-modal');
  if (!modal) return;

  // ヘッダーの「カートを見る」→ ページ遷移せずドロワーを開く
  // （JSが動かない環境では通常どおり /cart へ遷移する）
  const cartBtn = document.getElementById('cart-btn');
  if (cartBtn) {
    cartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  }

  // 閉じる操作（×ボタン・背景のクリック）
  const closeBtn = document.getElementById('close-cart-btn');
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

  const overlay = document.getElementById('cart-overlay');
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  // Escキーで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeCartDrawer();
    }
  });
}

/**
 * カートドロワーを開く（中身は開くたびに取得し直す）
 */
function openCartDrawer() {
  const modal = document.getElementById('cart-modal');
  if (!modal) {
    // ドロワーが無いページでは従来どおりカートページへ移動する
    window.location.href = window.Shopify.routes.root + 'cart';
    return;
  }

  captainLastFocused = document.activeElement;

  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  // 背景が一緒にスクロールしてしまうのを防ぐ
  document.body.classList.add('is-cart-open');

  refreshCartDrawer();

  const closeBtn = document.getElementById('close-cart-btn');
  if (closeBtn) closeBtn.focus();
}

/**
 * カートドロワーを閉じる
 */
function closeCartDrawer() {
  const modal = document.getElementById('cart-modal');
  if (!modal) return;

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('is-cart-open');

  // 開く前に操作していたボタンへフォーカスを戻す
  if (captainLastFocused && typeof captainLastFocused.focus === 'function') {
    captainLastFocused.focus();
  }
}

/**
 * カートの最新状態を取得してドロワーに描画する
 */
function refreshCartDrawer() {
  const itemsArea = document.getElementById('cart-items');
  if (itemsArea) {
    itemsArea.innerHTML = '<p class="cart-drawer__loading">読み込み中...</p>';
  }

  fetch(window.Shopify.routes.root + 'cart.js')
    .then((res) => res.json())
    .then((cart) => {
      renderCartDrawer(cart);
      updateCartBadge();
      updateStickyCta(cart);
    })
    .catch((error) => {
      console.error('Error:', error);
      if (itemsArea) {
        itemsArea.innerHTML =
          '<p class="cart-drawer__loading">カートを読み込めませんでした。<a href="' +
          window.Shopify.routes.root +
          'cart">カートページを開く</a></p>';
      }
    });
}

/**
 * カートの中身をドロワーに描画する
 * @param {object} cart - cart.js のレスポンス
 */
function renderCartDrawer(cart) {
  const progressArea = document.getElementById('shipping-progress-area');
  const itemsArea = document.getElementById('cart-items');
  const footerArea = document.getElementById('cart-footer');
  if (!itemsArea || !footerArea) return;

  // ----- カートが空のとき -----
  if (!cart.items || cart.items.length === 0) {
    if (progressArea) progressArea.innerHTML = '';
    itemsArea.innerHTML =
      '<div class="cart-drawer__empty">' +
      '<p class="cart-drawer__empty-text">カートに商品は入っていません</p>' +
      '<a href="' +
      window.Shopify.routes.root +
      '#products" class="btn btn--primary btn--block" onclick="closeCartDrawer()">商品一覧を見る</a>' +
      '</div>';
    footerArea.innerHTML = '';
    return;
  }

  // ----- 送料無料までの進捗 -----
  if (progressArea) {
    const totalYen = Math.round(cart.total_price / 100);
    const restYen = CAPTAIN_FREE_SHIPPING_YEN - totalYen;
    const percent = Math.min(100, (totalYen / CAPTAIN_FREE_SHIPPING_YEN) * 100);

    progressArea.innerHTML =
      '<p class="cart-drawer__ship-text">' +
      (restYen > 0
        ? 'あと <strong>¥' + restYen.toLocaleString('ja-JP') + '</strong> で送料無料'
        : '<strong>送料無料</strong>でお届けします') +
      '</p>' +
      '<div class="cart-drawer__ship-bar"><span class="cart-drawer__ship-bar-fill" style="width:' +
      percent +
      '%"></span></div>';
  }

  // ----- 商品リスト -----
  itemsArea.innerHTML = cart.items
    .map((item) => {
      const img = item.image
        ? '<img src="' +
          escapeHtml(item.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, '_150x$1$2')) +
          '" alt="" width="60" height="60" loading="lazy">'
        : '';
      // 定期便（サブスク）で追加された商品はラベルを出す
      const planName = item.selling_plan_allocation
        ? '<span class="cart-item__plan">' +
          escapeHtml(item.selling_plan_allocation.selling_plan.name) +
          '</span>'
        : '';
      // 「Default Title」はShopifyの初期値なので表示しない
      const variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';

      return (
        '<div class="cart-item">' +
        '<a href="' + escapeHtml(item.url) + '" class="cart-item__thumb">' + img + '</a>' +
        '<div class="cart-item__info">' +
        '<div class="cart-item__header">' +
        '<a href="' + escapeHtml(item.url) + '" class="cart-item__name">' + escapeHtml(item.product_title) + '</a>' +
        '</div>' +
        variant +
        planName +
        '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
        '<div class="cart-item__ctrl">' +
        '<button type="button" class="btn-qty" aria-label="数量を減らす" onclick="changeCartQty(\'' + escapeHtml(item.key) + '\', ' + (item.quantity - 1) + ')">−</button>' +
        '<span class="cart-item__qty">' + item.quantity + '</span>' +
        '<button type="button" class="btn-qty" aria-label="数量を増やす" onclick="changeCartQty(\'' + escapeHtml(item.key) + '\', ' + (item.quantity + 1) + ')">＋</button>' +
        '<button type="button" class="cart-item__remove" onclick="changeCartQty(\'' + escapeHtml(item.key) + '\', 0)">削除</button>' +
        '</div>' +
        '</div>' +
        '</div>'
      );
    })
    .join('');

  // ----- 合計とレジへの導線 -----
  // 重量オーバーのときはカートページと同じ理由でレジに進めないようにする
  const isOverWeight = cart.total_weight > CAPTAIN_WEIGHT_LIMIT_G;

  footerArea.innerHTML =
    (isOverWeight
      ? '<p class="cart-drawer__alert">1度のご注文は最大20セット(500個)までです。数量を減らすか、2回に分けてご注文ください。</p>'
      : '') +
    '<div class="cart-drawer__total">' +
    '<span>小計（税込）</span>' +
    '<strong>' + formatMoney(cart.total_price) + '</strong>' +
    '</div>' +
    '<p class="cart-drawer__note">送料はチェックアウト時に計算されます</p>' +
    '<a href="' + window.Shopify.routes.root + 'checkout" class="btn btn--primary btn--block cart-drawer__checkout' +
    (isOverWeight ? ' is-disabled" aria-disabled="true' : '') +
    '">レジへ進む</a>' +
    '<a href="' + window.Shopify.routes.root + 'cart" class="cart-drawer__link">カートページで確認する</a>';
}

/**
 * ドロワー内の数量変更（ページを再読み込みせずに更新する）
 * @param {string} key - カート内アイテムのKey
 * @param {number} qty - 変更後の数量（0で削除）
 */
function changeCartQty(key, qty) {
  if (qty < 0) qty = 0;

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
    .then((res) => {
      if (res.ok) return res.json();
      throw res;
    })
    .then((cart) => {
      renderCartDrawer(cart);
      updateCartBadge();
      updateStickyCta(cart);
    })
    .catch((error) => {
      if (error && error.json) {
        error.json().then((data) => {
          alert(data.description || '在庫が不足しているため、これ以上数量を増やせません。');
          refreshCartDrawer();
        });
      } else {
        console.error('Error:', error);
        alert('カートの更新に失敗しました。');
      }
    });
}

// =========================================
// 画面下の固定ボタン（スマホ用）
// =========================================

/**
 * カートの状態に合わせて固定ボタンの表示を切り替える
 * ・カートが空 → 「ラインナップを見る」
 * ・商品が入っている → 「カートを見る（N点・金額）」
 * ※商品ページは「カートに入れる」を出し続けたいので切り替えない
 * @param {object} cart - cart.js のレスポンス
 */
function updateStickyCta(cart) {
  const wrap = document.getElementById('sticky-cta');
  if (!wrap || wrap.dataset.page === 'product') return;

  const main = document.getElementById('sticky-cta-main');
  const cartBtn = document.getElementById('sticky-cta-cart');
  if (!main || !cartBtn) return;

  if (cart && cart.item_count > 0) {
    const count = document.getElementById('sticky-cta-count');
    const total = document.getElementById('sticky-cta-total');
    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = formatMoney(cart.total_price);

    main.hidden = true;
    cartBtn.hidden = false;
  } else {
    main.hidden = false;
    cartBtn.hidden = true;
  }
}

/**
 * 商品ページの固定ボタンから、選択中の種類・数量でカートに入れる
 */
function addToCartFromProductForm() {
  const select = document.querySelector('.product-form__select');
  const hidden = document.querySelector('.product-page [name="id"]');
  const variantId = select ? select.value : hidden ? hidden.value : null;
  if (!variantId) return;

  const qtyInput = document.getElementById('Quantity');
  const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  addToCart(variantId, qty, null);
}
